import { render, staticRenderFns } from "./ChangeRank.vue?vue&type=template&id=389276a8&"
import script from "./ChangeRank.vue?vue&type=script&lang=js&"
export * from "./ChangeRank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports